
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Pestwurzextrakt könnte hilfreich sein. Mutterkraut scheint ebenfalls eine
Wirkung zu haben, allerdings nur schwach. Es reduzierte die Anzahl der
monatlichen Attacken von 4,8 auf 2,9 – das waren 0,6 Anfälle weniger als mit
Placebo. Solche Durchschnittswerte können jedoch täuschen, denn im Einzelfall
gibt es bei allen vorbeugenden Mitteln Betroffene, die kaum noch Migräneattacken
erleiden. All diese Studien erlauben aber kein abschliessendes Fazit, weil sie
zu wenige Teilnehmer hatten, andere Mängel – oder weil sie zu widersprüchlichen
Ergebnissen kamen. Mutterkraut-Tee nützt übrigens nichts, weil die Inhaltsstoffe
nicht ins Wasser übergehen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;